import { UtilityFunctions } from 'app/shared/utilities/functions.models';

import { SizeGroupTypeEnum } from '../../enum/size-group-type.enum.model';
import { ProductTier, TierVM } from '../settings/tier.model';
import { ProductTagDTO, SizeDTO } from './product.models';
import { VariantPaletteDTO } from './variant.models';

export class BulkEditorVariantDTO {
  public id: number;
  public visibleForReOrder: boolean;
  public visibleForPreOrder: boolean;
  public blockQuantityBasedReOrderVisibility: boolean;
  public blankCellsEndDate: string;
  public blankCellsDeliveryDate: string;
  public wholesalePriceForReOrder: number;
  public wholesalePriceForPreOrder: number;
  public retailPriceForPreOrder: number;
  public retailPriceForReOrder: number;
  public tierList: ProductTier[] | number[];
  public tagList: ProductTagDTO[] | number[];
  public imagePath?: string;
  public code?: string;
  public size: SizeDTO;
  public palette: VariantPaletteDTO;
  public lastAppliedWholesaleDiscountPercentage: number;
  public cost: number;

  constructor(init?: BulkEditorVariantDTO) {
    Object.assign(this, init);
  }
}

export class BulkEditorVariantVM extends BulkEditorVariantDTO {
  public sizeName: string;
  public sizeGroup: SizeGroupTypeEnum;
  public colorName: string;
  public checked?: boolean;
  public disabled?: boolean;
  public tiersData: { data?: TierVM[], nextData?: TierVM[], page?: number, size: number, loaderId: string, search?: string; };
  public tagsData: { data?: ProductTagDTO[], nextData?: ProductTagDTO[], page?: number, size: number, loaderId: string, search?: string; };
  public overrideWholesaleDiscountPercentage: number;

  constructor(init?: BulkEditorVariantDTO) {
    super(init);
    if (!this.tiersData) this.tiersData = {
      size: 20,
      loaderId: UtilityFunctions.newGuid()
    };
    if (!this.tagsData) this.tagsData = {
      size: 20,
      loaderId: UtilityFunctions.newGuid()
    };
  }
}
export interface BulkEditorListItemSnapshot {
  id: number;
  name: string;
}

export interface BulkEditorVariantSnapshot {
  visibleForPreOrder: boolean;
  visibleForReOrder: boolean;
  blockQuantityBasedReOrderVisibility: boolean;
  blankCellsEndDate: string;
  blankCellsDeliveryDate: string;
  retailPriceForPreOrder: number;
  retailPriceForReOrder: number;
  overrideWholesaleDiscountPercentage: number;
  tagList: BulkEditorListItemSnapshot[];
  tierList: BulkEditorListItemSnapshot[];
}

export class BulkEditorChangeVM {
  public oldValue?: string;
  public newValue?: string;

  constructor(init?: BulkEditorChangeVM) {
    Object.assign(this, init);
  }
}

export class BulkEditorVariantChangeRecap {
  public id: number;
  public code: string;
  public colorName: string;
  public sizeName: string;
  public changes: BulkEditorChangeVM[];

  constructor(init?: BulkEditorVariantChangeRecap) {
    Object.assign(this, init);
  }
}

export class BulkEditorActionRecap {
  public actionLabel: string;
  public variants: BulkEditorVariantChangeRecap[];

  constructor(init?: BulkEditorActionRecap) {
    Object.assign(this, init);
  }
}

export class BulkEditorVariantDTI {
  blankCellsDeliveryDate: string;
  blankCellsEndDate: string;
  blockQuantityBasedReOrderVisibility: boolean;
  visibleForPreOrder: boolean;
  visibleForReOrder: boolean;
  cost: number;
  overrideWholesaleDiscountPercentage: number;
  retailPriceForPreOrder: number;
  retailPriceForReOrder: number;
  tagList: number[];
  tierList: number[];
  id: number;
  constructor(init?: BulkEditorVariantDTI) {
    Object.assign(this, init);
  }
}
